import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@guandan/ui/tokens.css";
import "./styles.css";
import AdminApp from "./AdminApp";
import { registerAdminPwa } from "./pwa";

const root = document.getElementById("root");
if (!root) throw new Error("Missing #root");
createRoot(root).render(<StrictMode><AdminApp /></StrictMode>);
registerAdminPwa();
